export const COLUMNS = [{
  slots: {
    title: '产品标识'
  },
  dataIndex: 'mark',
  key: '1',
  align: 'center',
  width: 100
}, {
  slots: {
    title: '产品名称'
  },
  dataIndex: 'name',
  key: '4',
  align: 'center',
  width: 400
}, {
  slots: {
    title: '发布客户'
  },
  dataIndex: 'customerName',
  key: '9',
  align: 'center'
}, {
  slots: {
    title: '发布应用'
  },
  dataIndex: 'appName',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '状态'
  },
  dataIndex: 'status',
  key: '6',
  align: 'center',
  scopedSlots: {
    customRender: 'status'
  },
  width: 100
}, {
  slots: {
    title: '发布时间'
  },
  dataIndex: 'createAt',
  key: '7',
  align: 'center',
  width: 200
}, {
  slots: {
    title: '操作'
  },
  key: '8',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 200
}];
export const ACCOUNTTYPE = [{
  name: '发布客户',
  id: 0
}, {
  name: '承保机构',
  id: 1
}, {
  name: '中介机构',
  id: 2
}, {
  name: '平台',
  id: 10
}];
export const WeChatCOLUMNS = [{
  slots: {
    title: 'APPID'
  },
  dataIndex: 'aAppid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '公众号appID'
  },
  dataIndex: 'pAppid',
  key: '9',
  align: 'center'
}, {
  slots: {
    title: '小程序appID'
  },
  dataIndex: 'mAppid',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: '3',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '1',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const AlipayCOLUMNS = [{
  slots: {
    title: 'APPID'
  },
  dataIndex: 'aAppid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '回调地址'
  },
  dataIndex: 'callbackAddress',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '1',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const CUPCOLUMNS = [{
  slots: {
    title: '银行账号'
  },
  dataIndex: 'bankAccount',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '开户银行'
  },
  dataIndex: 'accountBank',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '账户类型'
  },
  dataIndex: 'accountType',
  key: '1',
  align: 'center',
  scopedSlots: {
    customRender: 'accountType'
  },
  customRender: (text, record) => {
    return text == 1 ? '对公账户' : '';
  }
}, {
  slots: {},
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const TripartiteCOLUMN = [{
  slots: {
    title: '账户主体'
  },
  dataIndex: 'customerName',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '三方'
  },
  dataIndex: 'type',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: 'app ID'
  },
  dataIndex: 'appId',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '商户号/银行账号'
  },
  dataIndex: 'mchid',
  key: '3',
  align: 'center'
}];
export const BILLINGMETHOD = [{
  name: '合单支付',
  id: 1
}, {
  name: '分账支付',
  id: 2
}, {
  name: '商户号直收',
  id: 3
}];
export const CONSOLIDATEDCOLUMN1 = [{
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '上级商户号'
  },
  dataIndex: 'upMchid',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: '回调地址'
  },
  dataIndex: 'callbackAddress',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '收款比例'
  },
  dataIndex: 'share',
  key: '3',
  align: 'center',
  scopedSlots: {
    customRender: 'share'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const CONSOLIDATEDCOLUMN2 = [{
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '上级商户号'
  },
  dataIndex: 'upMchid',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: '回调地址'
  },
  dataIndex: 'callbackAddress',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '固定金额'
  },
  dataIndex: 'share',
  key: '3',
  align: 'center',
  scopedSlots: {
    customRender: 'share'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const CONSOLIDATEDCOLUMN3 = [{
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '上级商户号'
  },
  dataIndex: 'upMchid',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: '回调地址'
  },
  dataIndex: 'callbackAddress',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '收款比例'
  },
  dataIndex: 'share',
  key: '3',
  align: 'center',
  scopedSlots: {
    customRender: 'share'
  }
}, {
  slots: {
    title: '主商户'
  },
  dataIndex: 'share',
  key: '6',
  align: 'center',
  scopedSlots: {
    customRender: 'isMain'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const CONSOLIDATEDCOLUMN4 = [{
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '上级商户号'
  },
  dataIndex: 'upMchid',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: '回调地址'
  },
  dataIndex: 'callbackAddress',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '固定金额'
  },
  dataIndex: 'share',
  key: '3',
  align: 'center'
}, {
  slots: {
    title: '主商户'
  },
  dataIndex: 'share',
  key: '6',
  align: 'center',
  scopedSlots: {
    customRender: 'isMain'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const DIRECTCOLUMN = [{
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: '4',
  align: 'center'
}, {
  slots: {
    title: '上级商户号'
  },
  dataIndex: 'upMchid',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: '回调地址'
  },
  dataIndex: 'callbackAddress',
  key: '2',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 80
}];
export const EproCOLUMN = [{
  slots: {
    title: '账户主体'
  },
  dataIndex: 'customerName',
  key: '2',
  align: 'center',
  scopedSlots: {
    customRender: 'customerName'
  }
}, {
  slots: {
    title: '商户号'
  },
  dataIndex: 'mchid',
  key: 'mchid',
  align: 'center'
}, {
  slots: {
    title: '上级商户号'
  },
  dataIndex: 'upMchid',
  key: '1',
  align: 'center'
}];
export const COLUMNSPLAN = [{
  slots: {
    title: '方案名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '方案代码'
  },
  dataIndex: 'code',
  key: '1',
  align: 'center'
}, {
  slots: {
    title: '保障金额'
  },
  dataIndex: 'amount',
  key: 'amount',
  align: 'center'
}, {
  slots: {
    title: '保障期限'
  },
  dataIndex: 'duration',
  key: '2',
  align: 'center',
  scopedSlots: {
    customRender: 'duration'
  }
}, {
  slots: {
    title: '保费'
  },
  dataIndex: 'price',
  key: '3',
  align: 'center'
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: '5',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 300
}];
export const PREMIUMCOLUMNS = [{
  slots: {
    title: '保费'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  slots: {
    title: '折扣方式'
  },
  dataIndex: 'discountMode',
  key: 'discountMode',
  align: 'center',
  scopedSlots: {
    customRender: 'discountMode'
  },
  width: 180
}, {
  dataIndex: 'discountRatio',
  key: 'discountRatio',
  align: 'center',
  scopedSlots: {
    customRender: 'discountRatio'
  },
  width: 180,
  slots: {
    title: '折扣比例'
  }
}, {
  dataIndex: 'discountAmount',
  key: 'discountAmount',
  align: 'center',
  scopedSlots: {
    customRender: 'discountAmount'
  },
  width: 180,
  slots: {
    title: '折扣价格'
  }
}, {
  slots: {
    title: '折扣后'
  },
  dataIndex: 'price',
  key: 'price',
  align: 'center',
  scopedSlots: {
    customRender: 'price'
  }
}, {
  slots: {
    title: '适用架构'
  },
  dataIndex: 'structureIds',
  key: 'structureIds',
  align: 'center',
  scopedSlots: {
    customRender: 'structureIds'
  },
  width: 250
}];
export const PREMIUMCOLUMNS1 = [{
  slots: {
    title: '保费'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center',
  scopedSlots: {
    customRender: 'name'
  }
}, {
  slots: {
    title: '折扣方式'
  },
  dataIndex: 'discountMode',
  key: 'discountMode',
  align: 'center',
  scopedSlots: {
    customRender: 'discountMode'
  },
  width: 180
}, {
  dataIndex: 'discountRatio',
  key: 'discountRatio',
  align: 'center',
  scopedSlots: {
    customRender: 'discountRatio'
  },
  width: 180,
  slots: {
    title: '折扣比例'
  }
}, {
  dataIndex: 'discountAmount',
  key: 'discountAmount',
  slots: {
    title: '折扣价格'
  },
  align: 'center',
  scopedSlots: {
    customRender: 'discountAmount'
  },
  width: 180
}, {
  slots: {
    title: '折扣后'
  },
  dataIndex: 'price',
  key: 'price',
  align: 'center',
  scopedSlots: {
    customRender: 'price'
  }
}, {
  slots: {
    title: '适用架构'
  },
  dataIndex: 'structureIds',
  key: 'structureIds',
  align: 'center',
  scopedSlots: {
    customRender: 'structureIds'
  },
  width: 250
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'action',
  key: 'action',
  align: 'center',
  scopedSlots: {
    customRender: 'action'
  },
  width: 90
}];
export const PREMIUMPLANCOLUMNS = [{
  slots: {
    title: '销售区域'
  },
  dataIndex: 'areaCodeName',
  key: 'areaCodeName',
  align: 'center'
}, {
  slots: {
    title: '保费'
  },
  dataIndex: 'price',
  key: 'price',
  align: 'center'
}];
export const ADDITIONALCOLUMNS = [{
  slots: {
    title: '产品名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '购买限制'
  },
  dataIndex: 'buyLimit',
  key: 'buyLimit',
  align: 'center',
  scopedSlots: {
    customRender: 'buyLimit'
  },
  customRender: (text, record) => {
    return text == 0 ? window.vm.$i18n.t('选购') : window.vm.$i18n.t('必购');
  }
}];
export const TERMSCOLUMNS = [{
  slots: {
    title: '文件名称'
  },
  dataIndex: 'name',
  key: 'name',
  align: 'center'
}, {
  slots: {
    title: '条款文件'
  },
  dataIndex: 'linkName',
  key: 'linkName',
  align: 'center',
  scopedSlots: {
    customRender: 'linkName'
  }
}, {
  slots: {
    title: '操作'
  },
  dataIndex: 'operation',
  key: 'operation',
  align: 'center',
  width: 200,
  scopedSlots: {
    customRender: 'operation'
  }
}];